import {Validator, Values} from 'b302-frontend-library';

class RangeValidator<T> extends Validator<T> {

    private readonly min: number;
    private readonly max: number;

    constructor(min: number, max: number) {
        super();
        this.min = min;
        this.max = max;
    }

    protected validate(field: keyof T, value: string, form: Values<T>): void {
        if (isNaN(Number(value))) {
            this.result.invalid('validation.number', [this.t(String(field))]);
            return;
        }

        const number = parseInt(value);

        if(!(number >= this.min && number <= this.max)) {
            this.result.invalid('validation.range', [
                this.t(String(field)),
                this.v(this.min),
                this.v(this.max)
            ]);
        }
    }
}

export const FV = {
    range: (min: number, max: number) => new RangeValidator(min, max),
};
